import { ChainId } from '@pancakeswap/sdk'
import addresses from 'config/constants/contracts'
import tokens from 'config/constants/tokens'
import { Address } from 'config/constants/types'

export const getAddress = (address: Address): string => {
  const chainId = process.env.REACT_APP_CHAIN_ID
  return address[chainId] ? address[chainId] : address[ChainId.MAINNET]
}

// export const getUSDTAddress = () => {
//   return getAddress(tokens.usdt.address)
// }

export const getBNONFTAddress = () => {
  return getAddress(addresses.BNO_NFT)
}

export const getBNONFTPOOLAddress = () => {
  return getAddress(addresses.BNO_NFT_POOL)
}

export const getCakeAddress = () => {
  return getAddress(tokens.cake.address)
}
export const getMasterChefAddress = () => {
  return getAddress(addresses.masterChef)
}
export const getMasterChefV2Address = () => {
  return getAddress(addresses.masterChefV2)
}
export const getMulticallAddress = () => {
  return getAddress(addresses.multiCall)
}
export const getWbnbAddress = () => {
  return getAddress(tokens.wbnb.address)
}
export const getUsdtAddress = () => {
  return getAddress(tokens.usdt.address)
}
export const getLotteryV2Address = () => {
  return getAddress(addresses.lotteryV2)
}
export const getPancakeProfileAddress = () => {
  return getAddress(addresses.pancakeProfile)
}
export const getPancakeRabbitsAddress = () => {
  return getAddress(addresses.pancakeRabbits)
}
export const getBunnyFactoryAddress = () => {
  return getAddress(addresses.bunnyFactory)
}
export const getClaimRefundAddress = () => {
  return getAddress(addresses.claimRefund)
}
export const getPointCenterIfoAddress = () => {
  return getAddress(addresses.pointCenterIfo)
}
export const getBunnySpecialAddress = () => {
  return getAddress(addresses.bunnySpecial)
}
export const getTradingCompetitionAddress = () => {
  return getAddress(addresses.tradingCompetition)
}
export const getEasterNftAddress = () => {
  return getAddress(addresses.easterNft)
}
export const getCakeVaultAddress = () => {
  return getAddress(addresses.cakeVault)
}
export const getReferrerAddress = ()=>{
  return getAddress(addresses.referrer);
}
export const getPredictionsAddress = () => {
  return getAddress(addresses.predictions)
}
export const getChainlinkOracleAddress = () => {
  return getAddress(addresses.chainlinkOracle)
}
export const getBunnySpecialCakeVaultAddress = () => {
  return getAddress(addresses.bunnySpecialCakeVault)
}
export const getBunnySpecialPredictionAddress = () => {
  return getAddress(addresses.bunnySpecialPrediction)
}
export const getBunnySpecialLotteryAddress = () => {
  return getAddress(addresses.bunnySpecialLottery)
}
export const getFarmAuctionAddress = () => {
  return getAddress(addresses.farmAuction)
}
export const getNftAddress = () => {
  return getAddress(addresses.nft)
}

export const getEggPoolAddress = () => {
  return getAddress(addresses.eggPool)
}
export const getEggShareAddress = () => {
  return getAddress(addresses.eggShare)
}
export const getDaoAddress = () => {
  return getAddress(addresses.dao)
}
export const getNftBoxAddress = () => {
  return getAddress(addresses.nftBox)
}
export const getNftMarketAddress = () => {
  return getAddress(addresses.nftMarket)
}
export const getNftAuctionAddress = () => {
  return getAddress(addresses.nftAuction)
}
export const getMiner5xAddress = () => {
  return getAddress(addresses.miner5xAddress)
}
export const getMiner5xTimerAddress = () => {
  return getAddress(addresses.miner5xTimerAddress)
}
export const getNftSaleAddress = () => {
  return getAddress(addresses.nftSale)
}
